import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IDimensionsGetDtoModel } from "../../models/product/dto/dimension/dimension-get-dto.model";
import { IDimensionsPutDtoModel } from "../../models/product/dto/dimension/dimension-put-dto.model";
import { EnvironmentService } from "../environment.service";

@Injectable({
    providedIn: 'root'
})
export class DimensionsService {
    fullPath: string;
    constructor(private readonly httpClient: HttpClient, public envService: EnvironmentService) {
        this.fullPath = `${envService.settings.apiUrl}/products`;
    }

    public update(model: IDimensionsPutDtoModel): Observable<any> {
        return this.httpClient.put<IDimensionsPutDtoModel>(`${this.fullPath}/${model.id}/dimensions`, model);
    }

    public get(id: string): Observable<IDimensionsGetDtoModel | undefined> {
        return this.httpClient.get<IDimensionsGetDtoModel>(`${this.fullPath}/${id}/dimensions`);
    }
}
